import { render, staticRenderFns } from "./defaultLayoutNew.vue?vue&type=template&id=03096616&"
import script from "./defaultLayoutNew.vue?vue&type=script&lang=js&"
export * from "./defaultLayoutNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports